import AttributeValue     from "./AttributeValue"
import ValuableMaterial   from "./ValuableMaterial"

/**
 * Represents AttributeValues of the type AttributeMaterialsGroupValue.
 *
 * @see attribute_values property of the AttributeInterface from expivi
 */
export default class AttributeMaterialGroupValue extends AttributeValue {

    /**
     * Sets the data and creates the valuable materials array
     *
     * @param data
     */
    constructor(data) {
        super(data)

        this.valuableMaterials = []
        let materials = this.get('attribute_value_valuable.material_group.materials', [])

        if (materials.length > 0) {
            for (let i = 0; i < materials.length; i++) {
                let material = materials[i];
                let valuableMaterial = new ValuableMaterial(material)
                this.valuableMaterials.push(valuableMaterial)
            }
        }
    }

    /**
     * Returns the material_group_id of the valuable object if exists.
     *
     * @returns {boolean|*}
     */
    getMaterialGroupId() {
        return this.get('valuable.material_group_id')
    }

    /**
     * Returns the selectable materials as an array of the type ValuableMaterial.
     *
     * @see ValuableMaterial
     * @returns {Array}
     */
    getValuableMaterials() {
        return this.valuableMaterials
    }

    /**
     * Returns the default valuable material
     *
     * @returns {null}
     */
    getDefaultValuableMaterial() {
        let defaultMaterial = null

        for (let i = 0; i < this.valuableMaterials.length; i++) {
            defaultMaterial = this.valuableMaterials[i].isDefault() ? this.valuableMaterials[i] : null

            if (defaultMaterial !== null) {
                return defaultMaterial
            }
        }

        return defaultMaterial
    }

    /**
     * Returns wheater there are any valuable materials or not
     *
     * @returns {boolean}
     */
    hasValuableMaterials() {
        return this.valuableMaterials.length > 0
    }
}
